









































































import {Component, Prop, Vue} from "vue-property-decorator";
import {ApiServer} from "@/request";

const BigNumber = require("big-number");

import {State, Action, Getter, Mutation} from "vuex-class";
import {DenormalizedWeightAndGetbalance, Erc20Model} from "../store/erc20/erc20_model";

const namespace = "Erc20";
@Component
export default class Banner extends Vue {
    @Getter("getPrice", {namespace}) private price: number;
    @Getter("getDWG", {namespace}) private getDWG: DenormalizedWeightAndGetbalance;

    @Mutation("setDWG", {namespace}) private setDWG;

    @Action("getSpotPrice", {namespace}) private getSpotPrice;
    @Action("getDenormalizedWeightAndGetbalance", {namespace}) private getDenormalizedWeightAndGetbalance;
    private date_ = "";
    private currentPrice = 0;

    private getPriceTime: number = 30000;

    private dataList: Array<any> = [];
    private endList: Array<any> = [];
    private tisText:string = 'Not Started Yet';

    private showEcharts = true;
    private endDate;
    public $echarts: any;
    private options = {

        tooltip: {
            trigger: "axis",
            formatter: (params) => {
                let data: any = params;
                data = data[0].data;
                let date = new Date(data.name);
                if (this.dataList[this.dataList.length - 1].name < data.name) {
                    return;
                }
                return data.value[1] + " <br/> " + this.dateFmt(date);
            },
            axisPointer: {
                animation: false
            }
        },

        xAxis: {
            type: "time",
            data: this.dataList.map((item) => {
                return item.date;
            }),
            axisLabel: {
                formatter: (value, idx) => {
                    let _date = new Date(value);
                    // return this.dateFmt(date);
                    let _houes = _date.getHours() > 10 ? _date.getHours() : `0${_date.getHours()}`;
                    let _getMinutes = _date.getMinutes() > 10 ? _date.getMinutes() : `0${_date.getMinutes()}`;
                    return [_date.getHours(), _getMinutes].join(":");
                }
            },
            splitLine: {
                show: false
            },
            boundaryGap: false,
            axisLine: {
                lineStyle: {
                    color: "#fff"
                }
            },
        },
        yAxis: {
            type: "value",
            splitLine: {
                show: false
            },
            boundaryGap: [0, "100%"],
            axisLine: {
                lineStyle: {
                    color: "#fff"
                }
            },
        },
        series: [
            {
                type: "line",
                showSymbol: false,
                // hoverAnimation: true,
                data: this.dataList,
                hoverAnimation: false,
                smooth: true,

                markLine: {
                    symbol: ["none", "none"],
                },
                lineStyle: {
                    color: "#12C0FD",
                    width: 1
                },
            },
            {

                type: "line",
                showSymbol: false,
                hoverAnimation: false,
                data: this.endList,
                smooth: true,
                itemStyle: {
                    normal: {
                        lineStyle: {
                            width: 2,
                            type: "dotted"  //'dotted'虚线 'solid'实线
                        }
                    }
                },

                lineStyle: {
                    color: "#fff",
                    width: 1
                },
                markLine: {
                    symbol: ["none", "none"],
                },
            },
        ]
    };

    private getConfig?: { status: number, endDate: string, showEchartsTime?: number } = {status: 0, endDate: "123"};

    private chart: any;


    public mounted() {
        this.init();
    }

    async init() {

        this.getConfig = await ApiServer.getConfig();
        this.endDate = new Date(this.getConfig.endDate);
        if (this.endDate.valueOf() - new Date().valueOf() > this.getConfig.showEchartsTime) {
            this.showEcharts = false;
            return;
        }else if(this.endDate.valueOf() < new Date().valueOf()){
            this.tisText = 'Ended';
            this.showEcharts = false;
            return;
        }
        if (this.getConfig.status == 0) {
            await this.echartsFn();
        }
        this.getCurrentPrice();
        this.countdown();
        setInterval(async () => {
            await this.getCurrentPrice();
        }, this.getPriceTime,);

    }


    async echartsFn() {
        let ele: any = document.getElementById("myEcharts");
        this.chart = this.$echarts.init(ele);
        await this.getPrice();
        setInterval(async () => {
            await this.getDenormalizedWeightAndGetbalance();
        }, this.getPriceTime,);
    }


    thousands(num: string): string {
        return num && num.toString()
            .replace(/\d+/, function(s) {
                return s.replace(/(\d)(?=(\d{3})+$)/g, "$1,");
            });
    }


    async getCurrentPrice() {
        await this.getSpotPrice();
        this.currentPrice = this.price;
        if (this.getConfig.status == 0) {
            this.dataList.push(this.randomData(this.currentPrice, this.dataList[this.dataList.length - 1].name + this.getPriceTime,));
            this.endListFu();
        }
    }


    countdown() {

        const end = this.endDate.valueOf();
        const now = new Date().valueOf();
        const msec: any = end - now;
        if (msec < 0) {
            return this.date_ = `Ended`;
        }
        let day: any = parseInt((msec / 1000 / 60 / 60 / 24).toString());
        let hr: any = parseInt((msec / 1000 / 60 / 60 % 24).toString()) + day * 24;
        let min: any = parseInt((msec / 1000 / 60 % 60).toString());
        let sec: any = parseInt((msec / 1000 % 60).toString());
        hr = hr > 9 ? hr : "0" + hr;
        min = min > 9 ? min : "0" + min;
        sec = sec > 9 ? sec : "0" + sec;
        this.date_ = `${hr}H ${min}m`;
        setTimeout(() => {
            this.countdown();
        }, 60000);
    }


    dateFmt(date: Date) {
        let
            month = "" + (date.getMonth() + 1),
            day = "" + date.getDate(),
            h = "" + date.getHours(),
            m = "" + date.getMinutes(),
            s = "" + date.getSeconds();
        if (month.length < 2) {
            month = "0" + month;
        }
        if (day.length < 2) {
            day = "0" + day;
        }
        if (h.length < 2) {
            h = "0" + h;
        }
        if (m.length < 2) {
            m = "0" + m;
        }
        if (s.length < 2) {
            s = "0" + s;
        }
        return [month, day].join("-") + "  " + [h, m, s].join(":");
    };


    async getPrice() {

        let data: any = await ApiServer.getHistoryPrice();
        data.priceList.map((ev) => {
            this.dataList.push(this.randomData(ev.price, ev.date));
        });
        await this.getDenormalizedWeightAndGetbalance();
        this.endListFu();
    }


    endListFu() {

        let _date = this.dataList[this.dataList.length - 1].value[0];
        let _tmpPrice: number = this.dataList[this.dataList.length - 1].value[1];
        console.log("----------------->Depict the tail", _tmpPrice);
        let _initPrice: number = this.dataList[this.dataList.length - 1].value[1];
        this.endList = [];
        let balanceA = BigNumber(this.getDWG.balanceA);
        let balanceB = BigNumber(this.getDWG.balanceB);
        let weightA = BigNumber(this.getDWG.weightA);
        let weightB = BigNumber(this.getDWG.weightB);
        for (let i = 0; i < 60 * 6; i++) {
            _tmpPrice = (balanceA / weightA) / (balanceB / weightB) * 1e12;
            if (_tmpPrice < _initPrice) {
                _date += 60000;
                this.endList.push(this.randomData(_tmpPrice, _date,),);
            }
            weightA = weightA.plus(9123263888888888);   // every min
            weightB = BigNumber(50000000000000000000).minus(weightA);
            if (_date > this.endDate.valueOf()) {
                break;
            }
        }
        this.options.series[1].data = this.endList;
        this.chart.setOption(this.options);
    }


    randomData(ev: number, date: any) {
        let now = new Date(date).valueOf();
        return {
            name: now,
            value: [
                now,
                ev
            ]
        };
    }
}
